import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Hidden from "@material-ui/core/Hidden";

import styles from "assets/jss/material-dashboard-pro-react/components/authNavbarStyle.js";

const useStyles = makeStyles(styles);

export default function AuthNavbar(props) {
  const classes = useStyles();
  const { color, brandText, brandLogo } = props;
  const appBarClasses = cx({
    [" " + classes[color]]: color
  });

  return (
    <AppBar position="static" className={classes.appBar + appBarClasses}>
      <Toolbar className={classes.container}>
        <Hidden smDown>
            <img alt='logo' className={classes.logo} src={brandLogo} />
            <span className={classes.title}>{brandText}</span>
        </Hidden>
        <Hidden mdUp>
          <div className={classes.flex}>
            <img alt='logo' className={classes.logoMobile} src={brandLogo} />
            <div className={classes.title}>{brandText}</div>
          </div>
        </Hidden>

      </Toolbar>
    </AppBar>
  );
}

AuthNavbar.propTypes = {
  color: PropTypes.oneOf(["primary", "info", "success", "warning", "danger", "default"]),
  brandText: PropTypes.string,
  brandLogo: PropTypes.string
};
